import React from 'react'
import './LoaderStyles.scss'

function Loader({message}) {
    return (
        // <div class="ajax-loader-cont-pageCreateModalLoader">
        //     <div class="ajax-loader-bg show"></div>
        //     <div class="ajax-loader show">
        //         <span class="dot"></span>
        //         <span class="dot"></span>
        //         <span class="dot"></span>
        //         <span class="dot"></span>
        //         <span class="dot"></span>
        //         {message?<p>{message}</p>:<></>}
        //     </div>
        // </div>
        <div id="overlay-loader">

            <div class="cv-spinner">
                <span class="spinner"></span>
            </div>
        </div>
    )
}

export default Loader
